import { render } from "./yinlianPay.vue?vue&type=template&id=2f499b50&scoped=true"
import script from "./yinlianPay.vue?vue&type=script&lang=js"
export * from "./yinlianPay.vue?vue&type=script&lang=js"

import "./yinlianPay.vue?vue&type=style&index=0&id=2f499b50&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-2f499b50"

export default script